module.exports = __webpack_public_path__ + "img/collection-diamondJewelry050Carat@2x.4e13956.jpg";